import React from "react";

// Summary cards shown above every order table (Total / Amount / Average).
// Amount cards only appear when the API returns those values for the tab.
const OrderSummary = ({ data }) => {
  const d = data?.data;
  const hasAmount = d?.total_selling_value !== undefined;
  return (
    <div className="order-summary">
      <div className="order-summary-card">
        <div className="order-summary-label">Total Orders</div>
        <div className="order-summary-value">{d?.total ?? 0}</div>
      </div>
      {hasAmount && (
        <>
          <div className="order-summary-card">
            <div className="order-summary-label">Total Amount</div>
            <div className="order-summary-value">
              ₹{Number(d?.total_selling_value || 0).toFixed(2)}
            </div>
          </div>
          <div className="order-summary-card">
            <div className="order-summary-label">Average Amount</div>
            <div className="order-summary-value">
              ₹{Number(d?.average_selling_value || 0).toFixed(2)}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OrderSummary;
